import { render, staticRenderFns } from "./VideoBackground.vue?vue&type=template&id=4679258d&"
import script from "./VideoBackground.vue?vue&type=script&lang=js&"
export * from "./VideoBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports